import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { BaseComponent } from '../BaseComponent.js';
export const Dot = forwardRef(function Dot({ dataTestId, ...props }, ref) {
    const iconRender = useCallbackRef((color) => _jsx("circle", { cx: '12', cy: '12', r: '6', fill: color }));
    return _jsx(BaseComponent, { ref: ref, dataTestId: dataTestId ?? 'dot-icon-svg', iconRender: iconRender, ...props });
});
